module.exports = __webpack_public_path__ + "img/carpark_pay_pin.55aa99dd.png";